module.exports = __webpack_public_path__ + "img/collapse.dd50a68a.svg";